export enum PhotoProcessingStatusEnum {
    Processing = "PROCESSING",
    Complete = "COMPLETE",
    Failed = "FAILED",
}